import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { FaTags } from "react-icons/fa";
import { useGetSubcategoriesByNameV2Query } from "../slices/categoryApiSlice";

const SubcategoryScreen = () => {
  const { categoryName } = useParams();
  const navigate = useNavigate();

  const {
  data: categoryData,
  isLoading,
  error,
  refetch,
} = useGetSubcategoriesByNameV2Query(categoryName, {
  refetchOnMountOrArgChange: true,
});

  console.log("categoryName param:", categoryName);
console.log("API returned categoryData:", categoryData);

  const subcategories = categoryData?.[0]?.subcategories || [];


  // Group subcategories in pairs (2 per row for mobile & above)
  const formatInPairs = (list = []) => {
    const sorted = list.slice().sort((a, b) =>
      a.toLowerCase().localeCompare(b.toLowerCase())
    );
    const pairs = [];
    for (let i = 0; i < sorted.length; i += 2) {
      pairs.push([sorted[i], sorted[i + 1]]);
    }
    return pairs;
  };

  const handleBack = () => {
    navigate("/category");
  };

  const handleSubcategoryClick = (subcategory) => {
    navigate(`/productlist/${subcategory}`);
  };

  // Array of colorful variants for buttons
  const colorVariants = [
    "primary",
    "success",
    "warning",
    "danger",
    "info",
    "secondary",
    "dark",
  ];

  const getVariant = (index) => colorVariants[index % colorVariants.length];

  return (
    <Container className="mt-3 px-2">
      <Button
        variant="outline-secondary"
        className="mb-3"
        onClick={handleBack}
      >
        ← Back to Category
      </Button>

      <h4 className="mb-5 text-center fw-bold">
        Explore Subcategories of{" "}
        <span className="text-decoration-underline text-primary">
          {categoryName}
        </span>
      </h4>

      {isLoading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <Alert variant="danger" className="text-center">
          Failed to load subcategories.
        </Alert>
      ) : subcategories.length === 0 ? (
        <Alert variant="warning" className="text-center">
          No subcategories found.
        </Alert>
      ) : (
        formatInPairs(subcategories).map((pair, rowIndex) => (
          <Row key={rowIndex} className="mb-3 justify-content-center">
            {pair.map((subcategory, i) =>
              subcategory ? (
                <Col
                  key={i}
                  xs={6}
                  sm={6}
                  md={4}
                  lg={3}
                  className="d-flex justify-content-center mb-2"
                >
                  <Button
                    onClick={() => handleSubcategoryClick(subcategory)}
                    variant={getVariant(rowIndex * 2 + i)}
                    className="w-100 text-white text-wrap shadow-sm d-flex align-items-center justify-content-center"
                    style={{
                      minHeight: "60px",
                      borderRadius: "10px",
                      fontSize: "0.95rem",
                    }}
                  >
                    <FaTags className="me-2" />
                    {subcategory}
                  </Button>
                </Col>
              ) : (
                <Col
                  key={i}
                  xs={6}
                  sm={6}
                  md={4}
                  lg={3}
                  className="d-none d-sm-block"
                />
              )
            )}
          </Row>
        ))
      )}
    </Container>
  );
};

export default SubcategoryScreen;
